import { render, staticRenderFns } from "./compliance-item-select.vue?vue&type=template&id=79bda921&"
import script from "./compliance-item-select.vue?vue&type=script&lang=js&"
export * from "./compliance-item-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports